import { IS_PROD_ENV } from 'src/api/axiosClient/constants';

export const autoRenewToggleSx = { height: 25, zIndex: 999 } as const;

export const datePickerContainerSx = { pt: 0 } as const;

export const halfWidthFieldSx = { width: '49%' } as const;

export const halfWidthLeadingFieldSx = { width: '49%', mr: '1%' } as const;

export const statusChipSx = { height: 20 } as const;

export const stepPanelSx = { mb: 2 } as const;

export const errorAlertSx = { mt: 1 } as const;

export const spreadDialogActionsSx = { justifyContent: 'space-between' } as const;

export const devOnlyFieldSx = { visibility: IS_PROD_ENV ? 'hidden' : 'visible' } as const;

export const phoneRowActionSx = { mb: 2.25 } as const;

export const tabActionButtonSx = { width: 150, mt: 2.5 } as const;
